import * as PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import Row from "react-bootstrap/Row";
import { FormattedMessage, useIntl } from "react-intl";
import { FilesModel as $FILES } from "../../../../../common/entities";
import ObjectUtils, { coalesce } from "../../../../../utils/ObjectUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faTimes, faUpload } from "@fortawesome/free-solid-svg-icons";
import { ButtonGroup, ButtonToolbar } from "react-bootstrap";

const { opt, getDeepProperty, findByTemplate } = ObjectUtils;

export const UploadRenderer = ({
  disabled,
  question,
  questionAnswer,
  removeQuestionAnswer,
  row,
  column,
  uploadFiles,
  downloadFile,
  selectFiles
}) => {
  const intl = useIntl();

  const selectedFiles = findByTemplate(questionAnswer.files, {
    [$FILES.rowName]: opt(row).name,
    [$FILES.columnName]: opt(column).name
  });

  const files = coalesce(getDeepProperty(selectedFiles, 0, $FILES.files), []);
  const enableUpload = files.length > 0;
  const answers = findByTemplate(opt(questionAnswer).answers, {
    label: opt(row).name,
    colLabel: opt(row).column
  });

  let selectedFilesName = "";
  files.map((file) => (selectedFilesName = `${selectedFilesName + file.name};`));

  return (
    <>
      <Row>
        <Col sm={12} md={12} lg={12}>
          <Button variant="secondary" disabled={disabled} onClick={() => uploadFiles(question, files)}>
            <FontAwesomeIcon icon={faEllipsisH} />
          </Button>

          <FormControl
            multiple
            type="file"
            disabled={disabled}
            className="hidden"
            onChange={(e) => {
              const filesArr = [];
              if (e.target.files) {
                for (let i = 0; i < e.target.files.length; i++) {
                  filesArr.push(e.target.files[i]);
                }
              }
              selectFiles(question, {
                [$FILES.files]: filesArr,
                [$FILES.rowName]: opt(row).name,
                [$FILES.columnName]: opt(column).name
              });
            }}
            enctype="multipart/form-data"
            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf, image/*"
          />
          <FormControl type="text" disabled={disabled} value={selectedFilesName} />
          <Button variant="secondary" onClick={() => uploadFiles(question, files)} disabled={disabled || !enableUpload}>
            <FontAwesomeIcon icon={faUpload} /> <FormattedMessage id="survey.editor.toolbox.upload" />
          </Button>
        </Col>
      </Row>

      {answers.map((answer, i) => (
        <Row key={i}>
          <Col lg={12} md={12} sm={12}>
            <ButtonToolbar>
              <ButtonGroup>
                <Button
                  variant="link"
                  title={intl.formatMessage({ id: "app.common.action.download" })}
                  onClick={() => downloadFile(answer.value)}
                >
                  {answer.value}
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  title={intl.formatMessage({ id: "app.common.action.remove" })}
                  onClick={() => removeQuestionAnswer(question, answer)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Col>
        </Row>
      ))}
    </>
  );
};

UploadRenderer.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object.isRequired,
  collection: PropTypes.array,
  removeQuestionAnswer: PropTypes.func,
  row: PropTypes.object,
  column: PropTypes.object
};

export default UploadRenderer;
